import React from 'react'
import { IPreviousPlanForm } from './previousPlanSchema'
import { Card, Col, Row } from 'react-angle-dashboard-components'
import InfoRow from '../../components/PlanCard/InfoRow'
import trashCan from '../../trashCan.svg'

interface IPreviousPlanCardProps {
  plan: IPreviousPlanForm
  onEdit: () => void
  onDelete: () => void
}

const PreviousPlanCard = ({
  plan,
  onEdit,
  onDelete
}: IPreviousPlanCardProps) => {
  return (
    <Card className="user-select-none" style={{ width: 300 }}>
      <Card.Body>
        <Col>
          <Row className="d-flex justify-content-between">
            <p
              style={{
                fontWeight: 600,
                fontSize: 16
              }}
            >
              {plan.planName}
            </p>
            <div className="d-flex">
              <i
                className="icon icon-pencil text-primary fs-12 mr-2"
                style={{ height: '100%', width: '0.8rem', cursor: 'pointer' }}
                onClick={onEdit}
              />
              <img
                src={trashCan}
                alt="delete"
                style={{ height: '100%', width: '0.8rem', cursor: 'pointer' }}
                onClick={onDelete}
              />
            </div>
          </Row>
        </Col>
        <Col>
          <InfoRow
            label="Ind INN Deductible ($)"
            value={plan.indInnDeductible}
          />
          <InfoRow label="Ind INN OOP Max ($)" value={plan.indInnOOP} />
          <InfoRow
            label="Member Coinsurance (%)"
            value={plan.memberCoinsurance}
          />
        </Col>
      </Card.Body>
    </Card>
  )
}

export default PreviousPlanCard
